import _Object$keys from 'babel-runtime/core-js/object/keys';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import _keyBy from 'lodash/keyBy';

import validateConfiguration from './validateConfiguration';

var filterOutRenderersToMatchChildren = function filterOutRenderersToMatchChildren() {
  var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var renderers = arguments[1];
  return children.reduce(function (filteredRenderers, child) {
    return _extends({}, filteredRenderers, _defineProperty({}, child.type, renderers[child.type]), filterOutRenderersToMatchChildren(child.children, renderers));
  }, {});
};

var makeFeatureRenderer = function makeFeatureRenderer(renderersByType) {
  return function (node) {
    if (!node) return null;

    var type = node.type,
        _node$data = node.data,
        data = _node$data === undefined ? {} : _node$data,
        _node$children = node.children,
        children = _node$children === undefined ? [] : _node$children;

    var renderer = renderersByType[type];

    if (!renderer) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('Node `' + type + '` does not have corresponding renderer in available set (`' + _Object$keys(renderersByType).join('`, `') + '`), so nothing will be rendered.');
      }
      return null;
    }

    if (process.env.NODE_ENV !== 'production') {
      validateConfiguration(renderer.schema, node);
    }

    var renderersByTypeForChildren = renderersByType;
    if (process.env.NODE_ENV !== 'production') {
      renderersByTypeForChildren = filterOutRenderersToMatchChildren(children, renderersByType);
    }

    /*
      @FIXME quickfix for https://jira.willhillatlas.com/browse/SBKS-2383
      Should be removed or can be also transformed to a warning for dev mode.
    */
    if (!renderer.render) {
      return null;
    }

    return renderer.render({ type: type, data: data, children: children }, makeFeatureRenderer(renderersByTypeForChildren));
  };
};

export default (function (renderers) {
  var renderersByType = _keyBy(renderers, 'type');
  return makeFeatureRenderer(renderersByType);
});
//# sourceMappingURL=make-feature-renderer.js.map